import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setLoading as setAuthLoading } from '../../store/slices/authSlice';
import Header from './Header';
import LoadingSpinner from './LoadingSpinner';

const Layout = ({ children }) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);

  // Fallback to prevent infinite loading - auto-clear loading after 15 seconds
  useEffect(() => {
    if (loading) {
      const timeout = setTimeout(() => {
        console.warn('Layout loading state cleared after 15 seconds timeout');
        dispatch(setAuthLoading(false));
      }, 15000);

      return () => clearTimeout(timeout);
    }
  }, [loading, dispatch]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center">
        <div className="text-center">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-indigo-600/20 rounded-3xl blur-3xl"></div>
            <div className="relative bg-white/60 backdrop-blur-xl border border-white/20 rounded-3xl p-12 shadow-2xl">
              <LoadingSpinner size="xl" />
              <h2 className="mt-6 text-2xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                Loading StreakKeeper
              </h2>
              <p className="mt-2 text-gray-600">Preparing your dashboard...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <Header />
      <main className="max-w-7xl mx-auto py-8 sm:px-6 lg:px-8">
        <div className="px-4 sm:px-0">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;